import React from "react";
import { FaEnvelope, FaExclamationTriangle } from "react-icons/fa";
import { Card } from "../UI/DesignStandards";
import { SUPPORT_EMAIL } from "../SEO/siteOrigin";

const SupportSection = () => {
  return (
    <Card
      className="mb-0"
      aria-labelledby="support-heading"
    >
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div
            className="w-10 h-10 bg-brand-cream rounded-lg flex items-center justify-center"
            aria-hidden="true"
          >
            <FaExclamationTriangle className="h-5 w-5 text-brand-muted" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 id="support-heading" className="heading-display text-lg mb-2">
            Need to delete your account?
          </h3>
          <p className="text-sm text-brand-muted mb-3">
            Account deletion is permanent and cannot be undone. Email support
            and we'll handle it.
          </p>
          <div className="flex items-center space-x-2">
            <FaEnvelope className="h-4 w-4 text-brand-muted" aria-hidden="true" />
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-brand-gold-ink hover:text-brand-charcoal underline text-sm"
              aria-label="Email support team for account deletion"
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SupportSection;
